export class NotificacionSistemaEncabezadoDTO {
  id:string;
  titulo:string;
  activo:boolean;
}
